<template>
    <div :class="[{'collapse': true}, {'show': show}]" :id="id">
        <slot/> 
    </div>
</template>

<script>
export default {
    /**
        tag
        name: ks-collapse
        description: checkbox field component 
    **/
    name: "ks-collapse",
    props: {
        /**
            attribute
            name: id 
            description: id
        **/
        id:{
            type: String,
            required: true
        },
        /**
            attribute
            name: show 
            description: show
        **/
        show:{
            type: Boolean,
            default: false
        } 
    }
}
</script>